export const REFUND_TAB_VALUES = {
  REFUND: 'refund'
}

export const REFUND_STATUS_UI_MAP = {
  received: { label: 'RECIBIDO', className: 'received-style' },
  sent: { label: 'ENVIADO', className: 'sent-style' },
  dispatched: { label: 'DESPACHADO', className: 'dispatched-style' },
  invoiced: { label: 'FACTURADO', className: 'billed-style' },
  billed: { label: 'FACTURADO', className: 'billed-style' },
  partial_refund: { label: 'PARCIAL', className: 'delivery-received-style' },
  refund: { label: 'RECHAZADO', className: 'delivery-received-style' },
  document_pending: { label: 'PENDIENTE', className: 'oc-pending-style' },
  in_process: { label: 'EN PROCESO', className: 'in-process-style' },
  processed: { label: 'PROCESADO', className: 'processed-style' },
  cancelled: { label: 'ANULADO', className: 'cancelled-style' },
  invalidated: { label: 'ERROR', className: 'refund-error-style' },
  partial: { label: 'PARCIAL', className: 'refund-partial-style' }
}

export const REFUND_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_db_ref'
    },
    {
      icon: 'account_box',
      label: 'Vendedor:',
      valueKey: 'salesman_name',
      filled: true
    },
    {
      icon: 'event',
      label: 'Fecha de creación:',
      valueKey: 'display_created_date',
      format: 'date'
    }
  ]
}

export const buildRefundTabs = () => [
  {
    value: REFUND_TAB_VALUES.REFUND,
    label: 'Devolución',
    icon: 'replay',
    iconSize: 20,
    filled: true
  }
]
